import { Directive } from "@angular/core";
import { NzTableVirtualScrollDirective } from "ng-zorro-antd/table";

@Directive({
  selector: "[ui-virtual-scroll]",
  exportAs: "uiVirtualScroll",
})
export class UiTableVirtualScrollDirective<T> extends NzTableVirtualScrollDirective<T> {}
